import React, { useMemo } from 'react';
import classnames from 'classnames';
import { addDays } from '@gp/utils/common';
import { getWeekDateOfDPSReport, getDPSReportWeekLabel } from '../../utils';

import type { IBaseProps } from '@home/types/common';
import type { IReportDateValue } from '.';

interface IReportDatePickerButtonProps extends IBaseProps {
  dateType?: 'week';
  value: IReportDateValue;
  /**
   * RangePicker组件在渲染自定义Button时，会自动注入onClick这个props方法
   * 并且一定要监听自定义Button的根节点dom的onClick事件，并且在onClick事件的回调里 调用onClick这个注入的props方法，否则点击RangePicker组件的自定义Button时，无法弹出日期选择面板
   */
  onClick?: (e: React.SyntheticEvent) => void;
}

const DATE_TYPE_NAMES = {
  week: 'Week',
};

const ReportDatePickerPlaceholder = () => (
  <span className="dbg-dps-report-datepicker__button__placeholder">Please select Date</span>
);

const ReportDatePickerButton: React.FC<IReportDatePickerButtonProps> = (props) => {
  const { style, className, dateType = 'week', value, onClick } = props;

  const dateTypeName = DATE_TYPE_NAMES[dateType];

  const dateRangePicker = useMemo<React.ReactElement | null>(() => {
    const { start_date: startDate, end_date: endDate } = value || {};
    if (!startDate || !endDate) return <ReportDatePickerPlaceholder />;
    const {
      startDateM: startDateMDPSReportWeek,
      startDate: startDateDPSReportWeek,
      endDate: endDateDPSReportWeek,
    } = getWeekDateOfDPSReport(addDays(startDate, 1), addDays(endDate, 1));

    return getDPSReportWeekLabel({
      start_date_dps_report_week: startDateDPSReportWeek,
      end_date_dps_report_week: endDateDPSReportWeek,
      year: startDateMDPSReportWeek?.get('weekYear') || Number.NaN,
      weeks_in_year: startDateMDPSReportWeek?.weeks() || Number.NaN,
    });
  }, [value]);

  return (
    <div style={style} className={classnames('dbg-dps-report-datepicker__button', className)} onClick={onClick}>
      <span className="dbg-dps-report-datepicker__button__prefix">{dateTypeName}</span>
      {dateRangePicker}
    </div>
  );
};

export default ReportDatePickerButton;
